<div class="new-user-creation-dialog">
    <div class="dialog-header">
        <div class="dialog-title-wrap">
            <h2 mat-dialog-title class="dialog-title">{{ titleText | translate }}</h2>
            <span class="dialog-required-marker">*</span>
            <span class="dialog-required-text">{{ 'ime.indicates.required.field' | translate }}</span>
        </div>
        <button type="button" class="close-btn" (click)="onClose()" aria-label="Close" [disabled]="submitting">
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="dialog-header-divider"></div>

    <mat-dialog-content class="dialog-body">
        <form [formGroup]="userForm" autocomplete="off">
            <h4 class="section-heading">{{ 'ime.user.details' | translate }}:</h4>

            <div class="form-grid">
                <div class="form-field">
                    <div class="mat-form-label">{{ 'ime.requestor' | translate }}:</div>
                    <mat-form-field class="w-100 support-ticket-field disabled-field">
                        <input matInput type="text" formControlName="requestor" readonly />
                    </mat-form-field>
                </div>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'organization.name' | translate }} <span class="req">*</span></div>
                    <mat-form-field class="w-100 support-ticket-field disabled-field">
                        <input matInput type="text" formControlName="organizationName" readonly />
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('orgId', 'required')">
                        {{ 'organization.name' | translate }} is required.
                    </small>
                </div>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'ime.new.user.name' | translate }} <span class="req">*</span></div>
                    <mat-form-field class="w-100 support-ticket-field">
                        <input matInput type="text" formControlName="newUsername" [maxlength]="USERNAME_MAX"
                            placeholder="{{ 'Enter Username' | translate }}" />
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('newUsername', 'required')">
                        {{ 'ime.new.username.is.required' | translate }}.
                    </small>
                    <small class="field-error" *ngIf="hasError('newUsername', 'pattern')">
                        {{ 'ime.no.special.characters.allowed' | translate }}.
                    </small>
                    <small class="field-error" *ngIf="hasError('newUsername', 'maxlength')">
                        {{ 'ime.maximum' | translate }} {{ USERNAME_MAX }} {{ 'ime.characters.allowed' | translate }}.
                    </small>
                </div>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'ime.new.user.email' | translate }} <span class="req">*</span></div>
                    <mat-form-field class="w-100 support-ticket-field">
                        <input matInput type="email" formControlName="newUserEmail"
                            placeholder="{{ 'Enter Email' | translate }}" />
                    </mat-form-field>
                    <small class="field-error" *ngIf="hasError('newUserEmail', 'required')">
                        {{ 'ime.new.user.email.required' | translate }}.
                    </small>
                    <small class="field-error" *ngIf="hasError('newUserEmail', 'email')">
                        {{ 'please.email.field.required' | translate }}.
                    </small>
                </div>
            </div>

            <div class="block">
                <label class="mat-form-label">{{ 'assign.stockroom' | translate }}:</label>
                <mat-radio-group class="support-ticket-radio-group" formControlName="assignType"
                    (change)="onAssignTypeChange($event.value)">
                    <mat-radio-button [value]="ASSIGN_AUTO">
                        {{ 'ime.auto.assign.stockroom' | translate }}
                    </mat-radio-button>
                    <mat-radio-button [value]="ASSIGN_MANUAL">
                        {{ 'ime.manual.assign.stockroom' | translate }}
                    </mat-radio-button>
                </mat-radio-group>
            </div>

            <section class="clone-panel" *ngIf="userForm.get('assignType')?.value === ASSIGN_AUTO">
                <h3>{{ 'ime.assign.stockrooms.groups.existing.users' | translate }}</h3>

                <div class="form-field">
                    <div class="mat-form-label">{{ 'ime.existing.user.login.id.to.clone' | translate }} <span
                            class="req">*</span></div>
                    <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
                        <mat-select disableOptionCentering
                            panelClass="support-ticket-select-panel support-ticket-searchable-panel"
                            formControlName="existingUserId" (openedChange)="onUserPanelOpened($event)"
                            (selectionChange)="onExistingUserChange($event.value)"
                            placeholder="{{ 'select.user' | translate }}">
                            <div class="select-search-wrap">
                                <mat-icon class="select-search-icon">search</mat-icon>
                                <input type="text" class="select-search-input"
                                    placeholder="{{ 'search' | translate }} {{ 'user' | translate }}"
                                    [value]="userFilterText" (keydown)="$event.stopPropagation()"
                                    (input)="filterUsers($any($event.target).value)" />
                            </div>
                            <div class="select-empty" *ngIf="!filteredExistingUsers.length">
                                {{ 'no.search.result' | translate }}
                            </div>
                            <mat-option *ngFor="let u of filteredExistingUsers" [value]="getUserId(u)">
                                {{ getUserDisplayName(u) }}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <div class="mat-form-label clone-scope-label">{{ 'ime.clone.scope' | translate}}</div>
                    <mat-radio-group class="support-ticket-radio-group clone-organization-scope"
                        formControlName="cloneOrganizationScope">
                        <mat-radio-button [value]="CLONE_SCOPE_CURRENT_ORG">
                            {{ 'ime.current.organization' | translate }}
                        </mat-radio-button>
                        <mat-radio-button [value]="CLONE_SCOPE_ALL_ORGS">
                            {{ 'ime.all.organizations' | translate }}
                        </mat-radio-button>
                    </mat-radio-group>
                </div>
            </section>

            <section class="alert-box" *ngIf="userForm.get('assignType')?.value === ASSIGN_MANUAL">
                <mat-icon class="alert-icon">error_outline</mat-icon>
                <div>
                    <p class="alert-title">{{ 'ime.alert.message' | translate }}</p>
                    <p class="alert-text">
                        {{ 'ime.you.have.selected.manual.assign.stock.assignment.should.done.manually' | translate }}
                    </p>
                </div>
            </section>

            <section class="clone-panel" *ngIf="userForm.get('assignType')?.value === ASSIGN_MANUAL">
                <h3>{{ 'ime.assign.stockrooms.groups.existing.users' | translate }}</h3>
                <div class="clone-row">
                    <div class="clone-inputs">
                        <div class="form-field">
                            <div class="mat-form-label">{{ 'ime.list.of.stockroom' | translate }}:</div>
                            <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
                                <mat-select disableOptionCentering panelClass="support-ticket-select-panel"
                                    formControlName="stockroomId" placeholder="{{ 'Select Stockroom' | translate }}">
                                    <mat-option *ngFor="let s of stockroomList" [value]="getStockroomId(s)">
                                        {{ getStockroomName(s) }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="form-field">
                            <div class="mat-form-label">{{ 'group.name' | translate }}:</div>
                            <mat-form-field appearance="outline" color="primary" class="w-100 support-ticket-field">
                                <mat-select disableOptionCentering panelClass="support-ticket-select-panel"
                                    formControlName="groupId" placeholder="{{ 'Select Group' | translate }}">
                                    <mat-option *ngFor="let g of groupList" [value]="getGroupId(g)">
                                        {{ getGroupName(g) }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>

                    <button type="button" class="btn-add" [disabled]="!canAdd" (click)="addAssignment()">
                        <span>{{ 'add' | translate | titlecase }}</span>
                        <mat-icon class="btn-add-icon">add</mat-icon>
                    </button>
                </div>

                <div class="assign-list" *ngIf="assignments.length">
                    <hr class="panel-divider" />
                    <h4>{{ 'ime.assignment.list' | translate }}</h4>
                    <p class="lsub">
                        {{ 'ime.review.manage.assignments.before.submitting' | translate }}
                        ({{ assignments.length }} {{ (assignments.length === 1 ? 'assignment' : 'assignments') |
                        translate }})
                    </p>
                    <table class="assign-table">
                        <thead>
                            <tr>
                                <th>{{ 'stockroom.name' | translate }}</th>
                                <th>{{ 'group.name' | translate }}</th>
                                <th class="actions-col">actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let a of assignments; let i = index">
                                <td>{{ a.stockroomName }}</td>
                                <td>{{ a.groupName }}</td>
                                <td class="actions-col">
                                    <button type="button" class="row-delete-btn" (click)="removeAssignment(i)"
                                        aria-label="Remove assignment">
                                        <mat-icon>delete_outline</mat-icon>
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </section>

            <div class="block">
                <div class="mat-form-label">{{ 'comments' | translate }}:</div>
                <mat-form-field class="w-100 support-ticket-field support-ticket-textarea">
                    <textarea matInput formControlName="comments" rows="4" [maxlength]="COMMENT_MAX"
                        placeholder="{{ 'Enter your valuable comments...' | translate }}"></textarea>
                </mat-form-field>
            </div>
        </form>
    </mat-dialog-content>

    <div class="dialog-footer">
        <button type="button" class="cancel-btn" (click)="onClose()" [disabled]="submitting">{{ 'cancel' | translate
            }}</button>
        <button type="button" class="submit-btn" (click)="submit()" [disabled]="submitting">
            <span *ngIf="!submitting">{{ 'submit' | translate }}</span>
            <mat-spinner *ngIf="submitting" diameter="18" class="submit-spinner"></mat-spinner>
        </button>
    </div>
</div>